module.exports = __webpack_public_path__ + "static/media/typeD.771e6794.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banners/hero/typeD.png
// module id = 1220
// module chunks = 0